import React, { FC } from 'react'
import { Wrapper, Element } from './styled'

export const AdvantagesComponent: FC = () => (
	<Wrapper>
		<Element
			title="Удобная подача заявления"
			text="При встрече с менеджером в офисе Сбера или на выезде"
		/>
		<Element title="Расчетный счет для бизнеса" text="Бесплатно откроем и подарим бонусы" />
		<Element
			title="Экономия до 4 000 ₽"
			text="Не нужно платить госпошлину при регистрации бизнеса в Сбере"
		/>
	</Wrapper>
)
